import React from 'react';

const ActionButton = ({ onClick, children, variant = 'primary', className = '' }) => {
    const baseStyle = "w-full max-w-[280px] mx-auto block py-4 px-8 rounded-full font-black text-xl text-center uppercase tracking-widest transition-all transform hover:scale-105 active:scale-95 shadow-lg";
    
    const variants = {
        primary: "bg-gradient-to-r from-yellow-500 to-orange-500 text-white shadow-orange-500/50",
        secondary: "bg-transparent border-2 border-purple-500 text-white shadow-purple-500/20 hover:bg-purple-500/10",
        outline: "bg-transparent border border-white/30 text-white text-sm py-2 px-6 rounded-[30px] hover:bg-white/10"
    };

    return (
        <button 
            onClick={onClick} 
            className={`${baseStyle} ${variants[variant]} ${className}`}
        >
            {children}
        </button>
    );
};

export default ActionButton;
